<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Grid from '../Shared/Grid'

export default {
  name: 'UserGridRecruiter',
  components: {
    Grid
  },
  data () {
    return {
      filterable: true,
      module: this.$route.meta.module,
      columnOptions: [
        { field: 'COURSE_NAME', name: 'COURSE_NAME', label: 'Course Name', sortable: true, filterable: true, filter: '', type: 'string' }
      ]
    }
  },
  computed: {
    ...mapGetters('users', [
      'recruiterList'
    ]),
    ...mapState('users', {
      loadingData: state => state.loadingData
    })
  },
  methods: {
    ...mapActions('users', [
      'fetch',
      'select',
      'addNew'
    ])
  }
}
</script>

<template>
  <Grid
    :module="module"
    :data="recruiterList"
    :columns="columnOptions"
    :onSelect="select"
    :loading="loadingData"
    :filterable="filterable"
  />
</template>
